import { renderTemplate } from '../../Utils/templateUtils';

export default class BlogApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(BlogApi.getAllBlogPostsPath);
        // this.DashAPI.ApiPathMgr.add(BlogApi.getBlogPostByIdPath);
        // this.DashAPI.ApiPathMgr.add(BlogApi.getFeaturedBlogPostsPath);
        // this.DashAPI.ApiPathMgr.add(BlogApi.createBlogPostPath);
        // this.DashAPI.ApiPathMgr.add(BlogApi.updateBlogPostByIdPath);
        // this.DashAPI.ApiPathMgr.add(BlogApi.deleteBlogPostByIdPath);
    }

    getAllBlogPosts() {
        return this.DashAPI.CORE.get(BlogApi.getAllBlogPostsPath);
    }

    getBlogPostById(blogId) {
        var urlPath = renderTemplate(BlogApi.getBlogPostByIdPath, { blogId });
        return this.DashAPI.CORE.get(urlPath);
    }

    getFeaturedBlogPosts() {
        return this.DashAPI.CORE.get(BlogApi.getFeaturedBlogPostsPath);
    }

    createBlogPost(blogData) {
        return this.DashAPI.CORE.postFormData(BlogApi.createBlogPostPath, blogData);
    }

    updateBlogPostById(blogData) {
        const blogId = blogData.id;
        const urlPath = renderTemplate(BlogApi.updateBlogPostByIdPath, { blogId });
        return this.DashAPI.CORE.put(urlPath, blogData);
    }

    deleteBlogPostById(blogId) {
        const urlPath = renderTemplate(BlogApi.deleteBlogPostByIdPath, { blogId });
        return this.DashAPI.CORE.delete(urlPath);
    }
}

BlogApi.getAllBlogPostsPath         = '/api/secure/blog/trends';
BlogApi.getBlogPostByIdPath         = '/api/secure/blog/trends/{blogId}';
BlogApi.getFeaturedBlogPostsPath    = '/api/secure/blog/trends/featured';
BlogApi.createBlogPostPath          = '/api/secure/blog/trends';
BlogApi.updateBlogPostByIdPath      = '/api/secure/blog/trends/{blogId}';
BlogApi.deleteBlogPostByIdPath      = '/api/secure/blog/trends/{blogId}';



// WEBPACK FOOTER //
// ./src/DashApi/blog/BlogApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/blog/BlogApi.js